import * as Immutable from "immutable";
export default class FieldUnit {
  constructor(unitType, abbrev) {
    this._value = { unitType, abbrev };
  }
  get unitType() {
    return this._value.unitType;
  }
  get abbrev() {
    return this._value.abbrev;
  }
  get isDefined() {
    return this._value.abbrev && this._value.unitType;
  }
  toJSON() {
    const { abbrev, unitType } = this._value;
    return { abbrev, unit_type: unitType };
  }
  static fromJSON(value) {
    return new FieldUnit(value == null ? void 0 : value.unit_type, value == null ? void 0 : value.abbrev);
  }
  static empty() {
    return new FieldUnit(null, null);
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  abbrev(newUnit) {
    return new Builder(this.value.set("abbrev", newUnit));
  }
  unitType(newUnitType) {
    return new Builder(this.value.set("unitType", newUnitType));
  }
  build() {
    const { abbrev, unitType } = this.value.toObject();
    return new FieldUnit(unitType, abbrev);
  }
}
